<style lang="less">
.flex-table{
    overflow-x:auto !important;
  .ivu-row{
    padding:0;
    flex-wrap:nowrap;
  }
  .ivu-col{
    border-right:1px solid var(--border);
    flex-shrink: 0;
    flex-grow: 0;
    min-width: 0;
    overflow: hidden;
    word-break: break-word;
  }
  .ivu-col:last-child{
    border-right:none;
  }

  .caption-line{
    background:var(--bg2);
  }

  .ivu-form-item-content{
    padding:0 !important;

    .ivu-input-wrapper{
      width:100% !important;
      input{
        width:100% !important;
      }
    }
  }
  

}
</style>
<template>
  <div class="container flex-table">
      <Row
        :gutter="10"
        class-name="l-bill caption-line"
         align="middle"
      >
         <template v-for="(c,index) in columns">
           <Col :flex="computedColumnWidthds[index]" 
           :class="{'width-auto':c.width == 'auto'}"
           style="text-align:center;font-weight:bold" v-if="!c.if || model[c.if]" :key="c.key">{{c.name || ""}}</Col>
        </template>
        <Col :flex="computedOpColWidth" align="center"  v-if="!hideTool">操作</Col>
      </Row>

      <Row
        :gutter="10"
        class-name="l-bill"
         align="middle"
        v-if="design"
      >
         <template v-for="(c,index) in columns">
           <Col :flex="computedColumnWidthds[index]" 
           :class="{'width-auto':c.width == 'auto'}"
           style="text-align:center;color:var(--success)" :key="c.key">{{c.width || ""}}</Col>
        </template>
        <Col :flex="computedOpColWidth" align="center"  v-if="!hideTool">25%</Col>
      </Row>

      <Row
        :gutter="10"
        class-name="l-bill"
         align="middle"
        v-if="design"
      >
         <template v-for="(c,index) in columns">
           <Col :flex="computedColumnWidthds[index]" 
           :class="{'width-auto':c.width == 'auto'}"
           style="text-align:center;color:var(--subtext2)"  :key="c.key">{{computedColumnWidthds[index] || ""}}</Col>
        </template>
        <Col :flex="computedOpColWidth" align="center"  v-if="!hideTool">25%</Col>
      </Row>
      <Row
        :gutter="10"
        class-name="l-bill"
        align="middle"
        v-if="design"
      >
         <template v-for="(c,index) in columns">
            <Col :flex="computedColumnWidthds[index]" 
           :class="{'width-auto':c.width == 'auto'}"
           style="text-align:center;color:var(--subtext2)"  :key="c.key">{{ mapControlName(c.control) }}</Col>
        </template>
        <Col :flex="computedOpColWidth" align="center"  v-if="!hideTool">25%</Col>
      </Row>
      
      <!-- <Row
        :gutter="10"
        class-name="l-bill"
        v-if="design"
      >
         <template v-for="(c,index) in columns">
           <Col :flex="c.span || computedColumnWidthds[index]" 

           :class="{'width-auto':c.width == 'auto'}"
                      style="display:flex;overflow:hidden;text-align:center;align-items:center;"  :key="c.key">
              <div v-if="c.control=='drag'" class="draggable" style="cursor:grab">
                <BaseIcon icon="md-menu" />
              </div>
              <span v-else-if="c.control=='index'"  :key="'_colc'+c.key+index">{{index+1}}</span>
              <component v-else :is="c.control" size="small" :editable="true" :config="c.config"  />
              {{ c.item }}
           </Col>
        </template>
        <Col :span="4" align="center"  v-if="!hideTool">25%</Col>
      </Row> -->



      <Draggable
        v-model="items"
        :animation="500"
        handle=".draggable"
        @input="emitChange"
      >
        <template v-for="(item,index) in items">
          <Row :key="item.id" :gutter="10" class-name="l-bill">
            <template v-for="(c, colIndex) in columns">
              
            <Col :flex="computedColumnWidthds[colIndex]" 
            :class="{'width-auto':c.width == 'auto'}"
            :key="c.key" v-if="!c.if || model[c.if]" style="text-align:center">
           
              <div v-if="c.control=='drag'" class="draggable" style="cursor:grab;width:100%">
                <BaseIcon icon="md-menu" />
              </div>
              <span v-else-if="c.control=='index'"  :key="'_colc'+c.key+index">{{index+1}}</span>
              <component v-else :is="c.control" size="small" 
              style="max-width:100%;"
              :editable="true" :config="c.config"  @click="handleClick(c,item,index)" @input="emitChange" v-model="item[c.key]" />
              
            </Col>
            </template>
             <Col :flex="computedOpColWidth" v-if="!hideTool">
                 <div class="flex-wrap split5"><Button size="small" style="flex-shrink:0" @click="copy(index)" icon="md-copy"></Button><Button  style="flex-shrink:0" size="small" @click="remove(index)" icon="md-remove"></Button></div>
             </Col>
          </Row>
        </template>
      </Draggable>

      <BaseEmpty v-if="items.length == 0" image style="padding:20px;">
        <div class="flex-wrap flex-center" style="margin-bottom:20px" >
         <Button icon="md-add" size="small" @click="add">新增一行</Button>
          <slot name="button"></slot>
        </div>
      </BaseEmpty>
      <div v-else class="flex-wrap flex-between" style="margin:5px 10px">
        <Alert v-if="error" type="error" size="small" style="padding:3px 5px">{{error}}</Alert>
        <div class="flex-wrap"  style="margin-bottom:20px;margin-top:5px;">

          <Button icon="md-add" size="small" @click="add">新增一行</Button>
          <slot name="button"></slot>
        </div>
      </div>
      <Row :gutter="10" class-name="l-bill" v-if="summary && items.length > 0">
        <template v-for="(c,i) in columns">
        <Col :flex="computedColumnWidthds[i]"
        :class="{'width-auto':c.width == 'auto'}"
         :key="'_col_sum'+(c.key || i)" style="text-align:center">

          <span v-if="c.summarable"  :key="'_col_sum'+c.key">{{i+1}}</span>
        </Col>
        </template>
      </Row>
  </div>
</template>
<script>

import Draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';
function evil(fn, params) {
  params.fix = (total, items, key, index)=>{
    return formatNumber(total - formatNumber(items.filter((v, i)=>i!=index).reduce((acc, item)=>{
      return acc + item[key];
    }, 0)));
  };
  const Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
  return new Fn('params', 'console.log(params);console.log('+fn+');return ' + fn)(params);
}
function formatNumber(e) {
  if (isNaN(e)) {
    return 0;
  } else {
    return parseInt(e*100)/100;
  }
}
export default {
  components: {Draggable},
  data() {
    return {
      items: [],
      vid: 0,
      computedColumnWidthds: [],
      computedOpColWidth: '1px',
      _ftResizeObs: null,
    };
  },
  created() {
    this.vid = parseInt(Math.random()*10000);
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    design: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: ()=>([]),
    },
    error: {
      type: String,
      default: ()=>'',
    },
    summary: {
      type: Boolean,
    },
    model: {
      type: Object,
      default: ()=>({}),
    },
    ordered: {
      type: Boolean,
      default: true,
    },
    hideTool:{
      type: Boolean,
      default: false,
    }
  },
  watch: {
    value: {
      handler(v) {
        if (Array.isArray(this.value)) {
          this.items = cloneDeep(this.value);
          
        } else {
          this.items = [];
          this.emitChange();
        }
        this.$nextTick(() => this.ComputeColumnWidths());
      },
      immediately: true,
      deep: true,
    },
    columns: {
      deep: true,
      handler() {
        this.$nextTick(() => this.ComputeColumnWidths());
      },
    },
    model: {
      deep: true,
      handler() {
        this.$nextTick(() => this.ComputeColumnWidths());
      },
    },
    hideTool() {
      this.$nextTick(() => this.ComputeColumnWidths());
    },
  },
  mounted() {
    this.$bus.$on('calc-flex-table',()=>{
      this.ComputeColumnWidths()
    })
    if (Array.isArray(this.value)) {
      this.items = cloneDeep(this.value);
    } else {
      this.items = [];
      this.vid = parseInt(Math.random()*1000);
      this.emitChange();
    }

    this.$nextTick(()=>{
      this.ComputeColumnWidths()
    })
    if (typeof ResizeObserver !== 'undefined' && this.$el) {
      this._ftResizeObs = new ResizeObserver(() => {
        this.ComputeColumnWidths();
      });
      this._ftResizeObs.observe(this.$el);
    }
  },
  beforeDestroy() {
    this.$bus.$off('calc-flex-table');
    if (this._ftResizeObs) {
      this._ftResizeObs.disconnect();
      this._ftResizeObs = null;
    }
  },
  methods: {
    /**
     * View Design Col：flex 为数字时解析为「N N auto」，列宽随内容变，表头与表体易错位。
     * 这里统一输出带 px 的 flex（解析为 0 0 {px}），span 只参与剩余宽度按比例分配。
     */
    ComputeColumnWidths() {
      const el = this.$el;
      if (!el || !Array.isArray(this.columns)) {
        return;
      }
      const W = el.offsetWidth;
      if (!W) {
        return;
      }

      const isVisible = (c) => !c.if || this.model[c.if];
      const opSpan = this.hideTool ? 0 : 4;

      let fixedTotal = 0;
      const flexItemsFixed = [];

      this.columns.forEach((c, colIndex) => {
        if (!isVisible(c)) {
          return;
        }
        const resolved = c.width ? this.computeWidth(c.width) : 'auto';
        const explicit = c.width && resolved !== 'auto';
        if (explicit) {
          fixedTotal += parseFloat(resolved) || 0;
        } else {
          flexItemsFixed.push({ colIndex, span: Number(c.span) || 1 });
        }
      });

      const spanSum = flexItemsFixed.reduce((s, item) => s + item.span, 0) + opSpan;
      const remaining = Math.max(0, W - fixedTotal);
      const flexWidthByCol = new Map();

      if (spanSum > 0 && remaining >= 0) {
        const parts = flexItemsFixed.map((f) => f.span);
        if (opSpan) {
          parts.push(opSpan);
        }
        let acc = 0;
        const pixels = parts.map((span, i) => {
          const last = i === parts.length - 1;
          const v = last
            ? Math.max(0, remaining - acc)
            : Math.round(((remaining * span) / spanSum) * 100) / 100;
          if (!last) {
            acc += v;
          }
          return v;
        });
        flexItemsFixed.forEach((item, i) => {
          flexWidthByCol.set(item.colIndex, `${pixels[i]}px`);
        });
        this.computedOpColWidth = opSpan ? `${pixels[pixels.length - 1]}px` : '0px';
      } else {
        this.computedOpColWidth = opSpan ? `${remaining}px` : '0px';
      }

      this.computedColumnWidthds = this.columns.map((c, colIndex) => {
        if (!isVisible(c)) {
          return '0px';
        }
        const resolved = c.width ? this.computeWidth(c.width) : 'auto';
        const explicit = c.width && resolved !== 'auto';
        if (explicit) {
          return resolved;
        }
        return flexWidthByCol.get(colIndex) || '0px';
      });
    },
    mapControlName(control){
      if(control.includes('Zzl')){
        control = control.replace('Zzl','Ugo')
      }
      switch(control){
        case 'UgoInput':
          return '单行文本';
        case 'UgoNumber':
          return '数值';
        case 'UgoTextarea':
          return '多行文本';
        case 'UgoDate':
          return '日期';
        case 'UgoRadio':
          return '单选';
        case 'UgoInputSelect':
          return '输入选择框';
        case 'UgoFileUpload':
          return '文件';
        case 'UgoImage':
          return '图片';
        case 'UgoMultiSelect':
          return '多选';
        default:
          return control;
      }
    },
    computeWidth(width) {
      // 获取容器的宽度
      let total = this.$el ? this.$el.offsetWidth : 100;
      if(!width || width == 'auto') return 'auto';
    if (typeof width === 'string' && width.endsWith('%')) {
      // Convert percentage to 12 span grid (e.g. 50% => 6)
      const percent = parseFloat(width);
      if (!isNaN(percent)) {
        return `${Math.round(total * percent / 100)}px`;
      }
      return 'auto';
    }
    if (typeof width === 'number') {
      return width + 'px';
    }
    if (typeof width === 'string' && /^\d+$/.test(width)) {
      return width + 'px';
    }
    // fallback
    return width;
    },
    handleClick(c, item, index) {
      const model = this.model;
      if (c.control=='Button') {
        this.$set(item, c.to, formatNumber(evil(c.from, {model, item, index})));
      }
    },
    validate() {
      if (this.check_result.state == 'success') {
        return true;
      }
    },
    getError() {
      return this.check_result.message;
    },
    emitChange() {
      if (this.ordered) {
        this.items.forEach((v, i)=>v.order=(i+1));
      } else {
        this.items.forEach((v, i)=>delete v.order);
      }
      this.$emit('input', this.items);
    },
    add() {
      this.items.push({});
    },
    copy(i) {
      this.items.splice(i, 0, {...this.items[i], id: undefined});
      this.$emit('input', this.items);
    },
    remove(i) {
      this.items.splice(i, 1);
      this.$emit('input', this.items);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
